import { contentTypeParser } from "@circle-react/components/shared/uikit/TipTap/utilities/contentTypeParser";

import type { AttachmentGalleryItem } from "./types";

export const canDownloadGalleryAttachment = (
  attachment: AttachmentGalleryItem,
): boolean => {
  const isProtectedMedia =
    contentTypeParser.isVideo(attachment.content_type) ||
    contentTypeParser.isAudio(attachment.content_type);

  if (!isProtectedMedia) {
    return true;
  }

  return attachment.is_downloadable === true;
};
